import React from "react";

const corporationRoute = [
  {
    key: "welcome",
    path: `/welcome`,
    component: React.lazy(() => import("views/landing/Welcome")),
    authority: [],
  },
  {
    key: "privacy",
    path: `/privacy`,
    component: React.lazy(() => import("views/corporation/privacy")),
    authority: [],
  },
];

export default corporationRoute;
